import React from 'react';
import styles from './Divider.module.scss';
import { withClassNames } from '../HigherOrder/withClassNames';

const Divider = (props) => <hr {...props} />;

export default React.memo(withClassNames(Divider, styles));
